import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import Tab from './Tab.jsx';
import styles from './Tab.scss';

class Tabs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTab: 0
    };
  }

  renderTab = (tab, idx) => {
    let {
      selectedTab
    } = this.state;

    let tabProps = {
      title: tab.title,
      isSelected: selectedTab === idx,
      onSelected: () => {
        this.setState({selectedTab: idx});
        if (tab.onSelected) {
          tab.onSelected(tab);
        }
      }
    };

    return (<Tab key={idx} {...tabProps} />);
  }

  render() {
    let {
      tabs,
      ...rest
    } = this.props;

    let {
      selectedTab
    } = this.state;

    return (
      <div {...rest}>
        <div className={classnames(styles.tabContainer)}>
          {tabs.map(this.renderTab)}
        </div>
        <div>
          {tabs[selectedTab].render()}
        </div>
      </div>
    );
  }
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      onSelected: PropTypes.func,
      render: PropTypes.func.isRequired
    })
  )
};

export default Tabs;